import { SecureRoute } from '@okta/okta-react';
import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import { SpaceNewTabPaneContent } from 'components/organisms/spaces/space-tab';
import { TemplateState } from 'data/templates/api';
import {
  addDocumentFromTemplateAction,
  createDocumentTemplateAction,
  embedDocumentTemplateAction,
} from 'data/templates/documents/actions';
import type { DocumentTemplate } from 'data/templates/documents/types';
import { useTranslation } from 'hooks/use-translation';

export const ProjectSpaceTemplateNewTabPaneContent: FC<{ spaceId: number }> = ({
  spaceId,
}) => {
  const history = useHistory();
  const { path, url } = useRouteMatch();
  const dispatch = useDispatch();
  const [isCreatingDocument, setIsCreatingDocument] = useState(false);
  const [isEmbeddingDocument, setIsEmbeddingDocument] = useState(false);
  const templateName = useTranslation('untitled');

  const redirectToNewTab = (tabId: number) =>
    history.push(`${url}/tabs/${tabId}`);

  const handleNewEmbed = ({ url: _url }: { url: string }) => {
    setIsEmbeddingDocument(true);

    dispatch(
      embedDocumentTemplateAction({
        spaceId,
        url: _url,
        handleSuccess: (tabId: number) => redirectToNewTab(tabId),
        handleAlways: () => setIsEmbeddingDocument(false),
      }),
    );
  };

  const handleNewDocument = () => {
    setIsCreatingDocument(true);

    dispatch(
      createDocumentTemplateAction({
        spaceId,
        state: TemplateState.Published,
        templateName,
        handleSuccess: (templateId: number) => redirectToNewTab(templateId),
        handleAlways: () => setIsCreatingDocument(false),
      }),
    );
  };

  const handleChooseTemplate = (template: DocumentTemplate) => {
    dispatch(
      addDocumentFromTemplateAction({
        spaceId,
        template,
        handleSuccess: (tabId: number) => redirectToNewTab(tabId),
      }),
    );
  };

  return (
    <SecureRoute exact path={`${path}/tabs/new`}>
      <SpaceNewTabPaneContent
        isCreateInProgress={isCreatingDocument}
        isEmbedInProgress={isEmbeddingDocument}
        onCreateDocument={handleNewDocument}
        onCreateEmbed={handleNewEmbed}
        onChooseTemplate={handleChooseTemplate}
      />
    </SecureRoute>
  );
};
